import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Dialog from '@mui/material/Dialog';
import { useEffect, useMemo, useState } from "react";
import { photosStore } from "../../stores/posts/usePhotosStore";
import { Box, Grid, } from "@mui/material";
// import './ImageFullView.css';
import { textColor } from "../../assets/styles/colors";
// import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { do_nothing_function, timeSince, useHeight, useMobile, useWidth } from "common-frontend-components";
import { Image } from '../custom/images/Image';
import { postCategoryAssociationsStore } from "../../stores/posts/usePostCategoryAssociationsStore";
import { postsStore } from "../../stores/posts/postsStore";
import Typography from "@mui/material/Typography";
import { CategoryChip } from "../entities/categories/CategoryChip";
import { wwwLinks } from "../../variables/wwwRoutes";
import { PostLinks } from "../entities/posts/post/PostLinks";
import { OrderPhotos } from "../entities/posts/Photos/OrderPhotos";
import { globalAppConfigStore } from "../../stores/appConfig/globalAppConfigStore";
import { categoriesStore } from "../../stores/useCategoriesStore";
import { ImageFullViewStyle } from "./ImageFullViewStyle";
import { productsFullViewStore } from "../../stores/products/productsFullViewStore";
import { productPostAssociationsStore } from "../../stores/products/productPostAssociationsStore";
import { PostProductsFullViewCarousel } from "../entities/products/product/PostProductsCarousel";
const useImageFullViewProps = (img, postCategoryAssociations) => {
    const { categories, post } = useMemo(() => {
        const data = {
            categories: undefined,
            post: undefined,
        };
        // @ts-ignore
        if (!img || img.photos.length === 0 || !img.photos[0].postId)
            return data;
        // @ts-ignore
        data.post = postsStore.getPostMap()[img.photos[0].postId];
        if (!data.post)
            return data;
        data.categories = postCategoryAssociationsStore.getPostCategories(data.post.id);
        return data;
    }, [img, postCategoryAssociations]);
    return {
        categories,
        post,
    };
};
export const SliderImg = ({ onImgClick, photo }) => {
    const isMobile = useMobile();
    const width = useWidth();
    const height = useHeight();
    return (_jsx(Image, { src: photo.url, alt: 'image failed to load. please try again later.', onClick: onImgClick, maxHeight: height, maxWidth: isMobile ? width : width - 360 }, void 0));
};
export const ImageSlider = ({ imgSlider, setImgSlider, onImgClick = do_nothing_function, /*onClose*/ }) => {
    // @ts-ignore
    const photos = useMemo(() => !imgSlider ? [] : imgSlider.photos.filter(i => i.phototype !== 'preview'), [imgSlider?.photos]);
    if (photos.length === 0)
        return _jsx(_Fragment, {}, void 0);
    // Next/previous controls
    function plusSlides(n) {
        if (!imgSlider)
            return;
        imgSlider.index += n;
        if (imgSlider.index + 1 > photos.length)
            imgSlider.index = 0;
        else if (imgSlider.index < 0)
            imgSlider.index = photos.length - 1;
        setImgSlider({ ...imgSlider });
    }
    return (_jsx(Box, { sx: {
            boxSizing: 'border-box',
            '& *': {
                boxSizing: 'border-box',
            },
        }, children: _jsxs(Box, { className: "slideshow-container-ImageFullView", children: [photos.map((photo, index) => _jsxs(Box, { style: { display: index === imgSlider?.index ? 'block' : 'none' }, className: "mySlides-ImageFullView fade-ImageFullView", children: [_jsxs(Box, { className: "numbertext-ImageFullView", children: [index + 1, " / ", photos.length] }, void 0), _jsx(SliderImg, { onImgClick: onImgClick, photo: photo }, void 0)] }, index)), _jsx("a", { className: "prev-ImageFullView", onClick: (e) => { e.stopPropagation(); plusSlides(-1); }, children: "\u276E" }, void 0), _jsx("a", { className: "next-ImageFullView", onClick: (e) => { e.stopPropagation(); plusSlides(1); }, children: "\u276F" }, void 0)] }, void 0) }, void 0));
};
const ImageFullViewMeta = ({ imgSlider, post, categories, setImgSlider }) => {
    const [photos, setPhotos] = useState([]);
    const productPostAssociations = productPostAssociationsStore.useProductPostAssociations();
    const products = useMemo(() => productPostAssociationsStore.getPostProducts(post?.id || ""), [productPostAssociations, post?.id]);
    // @ts-ignore
    useEffect(() => { setPhotos(!imgSlider ? [] : imgSlider.photos.filter(i => i.phototype !== 'preview')); }, [imgSlider?.photos]);
    const isMobile = useMobile();
    return (post ? _jsxs(Grid, { container: true, sx: { width: '100%', maxWidth: isMobile ? 590 : 350 }, spacing: 2, children: [_jsx(OrderPhotos, { useItems: () => photos, setItems: setPhotos, onClick: (index) => setImgSlider(imgSlider ? { ...imgSlider, index } : undefined), parent: ({ children }) => _jsx(Grid, { item: true, xs: 12, onClick: e => { e.stopPropagation(); }, children: children }, void 0) }, void 0), _jsxs(Grid, { item: true, xs: 12, children: [!isMobile && _jsx(Typography, { sx: { fontSize: '1.2rem', color: textColor, margin: 0 }, color: "text.secondary", gutterBottom: true, children: post.title }, void 0), _jsx(Box, { sx: { paddingTop: isMobile ? 1 : 0, fontSize: isMobile ? '1rem' : '.9rem', fontWeight: 500, color: textColor + 'cc' }, children: timeSince(new Date(post.created)) }, void 0)] }, void 0), _jsxs(Grid, { item: true, xs: 12, children: [isMobile && _jsx(Typography, { sx: { fontSize: '1.2rem', color: textColor }, color: "text.secondary", gutterBottom: true, children: post.title }, void 0), _jsx(Typography, { sx: { fontSize: '1rem', color: textColor, whiteSpace: "pre-wrap" }, color: "text.secondary", gutterBottom: true, children: post.description }, void 0)] }, void 0), _jsx(PostLinks, { post: post }, void 0), products.length > 0 ?
                _jsx(Grid, { item: true, xs: 12, children: _jsx(PostProductsFullViewCarousel, { items: products }, void 0) }, void 0) : null, categories !== undefined ?
                _jsx(Grid, { item: true, xs: 12, children: _jsx(Grid, { container: true, spacing: 1, children: categories.map(i => _jsx(Grid, { item: true, children: _jsx(CategoryChip, { category: i, onClick: () => {
                                    categoriesStore.setCategoryFilters([i]);
                                    wwwLinks.galleryCategory({ "categoryId": i.id });
                                    photosStore.closeImageFullViewUrl();
                                    productsFullViewStore.closeFullView();
                                } }, void 0) }, i.id)) }, void 0) }, void 0)
                : null] }, void 0) : null);
};
const ImageFullViewResponsiveLayout = ({ img }) => {
    const isMobile = useMobile();
    const postCategoryAssociations = postCategoryAssociationsStore.usePostCategoryAssociations();
    const { categories, post } = useImageFullViewProps(img, postCategoryAssociations);
    if (isMobile)
        return (_jsxs(Grid, { container: true, justifyContent: 'center', children: [_jsx(ImageSlider, { imgSlider: img, setImgSlider: photosStore.setImageFullViewUrl }, void 0), _jsx(Box, { sx: { padding: 1, maxWidth: '100%' }, children: _jsx(ImageFullViewMeta, { post: post, categories: categories, imgSlider: img, setImgSlider: photosStore.setImageFullViewUrl }, void 0) }, void 0)] }, void 0));
    return (_jsxs(Grid, { container: true, children: [_jsx(Grid, { item: true, sx: { padding: 1, maxWidth: '100%' }, children: _jsx(ImageFullViewMeta, { post: post, categories: categories, imgSlider: img, setImgSlider: photosStore.setImageFullViewUrl }, void 0) }, void 0), _jsx(Grid, { item: true, children: _jsx(ImageSlider, { imgSlider: img, setImgSlider: photosStore.setImageFullViewUrl }, void 0) }, void 0)] }, void 0));
};
export const ImageFullViewPopup = () => {
    const img = photosStore.useImageFullViewUrl();
    const config = globalAppConfigStore.useComponent('body-background');
    const bodyBackground = (config?.params?.background || "").replace("$url", config?.url || "");
    const open = !!img;
    return (_jsxs(_Fragment, { children: [_jsx(ImageFullViewStyle, {}, void 0), _jsx(Dialog, { onClose: photosStore.closeImageFullViewUrl, open: open, fullScreen: true, onClick: photosStore.closeImageFullViewUrl, PaperProps: {
                    sx: {
                        background: `${bodyBackground} repeat`,
                        backgroundSize: 'cover',
                        overflowX: 'hidden',
                        backgroundPosition: '0 0',
                        animationName: 'ImageFullView-backgroundloop',
                        animationIterationCount: 'infinite',
                        animationDuration: '800s',
                        animationTimingFunction: 'linear',
                    }
                }, children: _jsx(Box, { sx: { minHeight: '100vh', width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', paddingBottom: 10 }, children: _jsx(ImageFullViewResponsiveLayout, { img: img }, void 0) }, void 0) }, void 0)] }, void 0));
};
//# sourceMappingURL=ImageFullView.js.map